module.exports = __webpack_public_path__ + "img/logo-title-center.5cde1c9a.svg";